import { combineReducers } from 'redux';

import experiments from './experiments';
import selectedVariants from './selectedVariants';
import userIdentifier from './userIdentifier';

import playedExperiments from './playedExperiments';

import { STATE_NAME } from '../constants';

export default combineReducers({
  experiments,
  selectedVariants,
  userIdentifier,
  playedExperiments,
});

const getState = state => state[STATE_NAME];

export const getPlayedExperiments = state => getState(state).playedExperiments;
export const getUserIdentifier = state => getState(state).userIdentifier;
export const getSelectedVariants = state => getState(state).selectedVariants;
